export default __webpack_public_path__ + "static/media/face_3_42.afb57211.png";